import React from 'react'

// material-ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

// data
import { useBrand } from 'components/shared/SettingsProvider'

const BrightHorizonsHeader = props => {
  const {
    contact: { email },
    marcomUrl
  } = useBrand()

  return (
    <Box my={2}>
      <Typography my={2} align='center' variant='subtitle1'>
        * For a full list of locations and additional information,{' '}
        <Link
          underline='always'
          href={`${marcomUrl}/bright-horizons-efs/`}
          target='_blank'
        >
          check out our website
        </Link>
        , or email us at <Link href={`mailto:${email}`}>{email}</Link>.
      </Typography>
    </Box>
  )
}

export default BrightHorizonsHeader
